<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData"></vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"></vue-pagination>
    </el-footer>
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import Statistics from "@view/components/Statistics"
  export default {
    name: "syslog",
    mixins: [PagingData],
    components: {Statistics},
    data() {
      return {
        // 统计
        countList: [
          {name: "总记录", count: 0},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "操作员", property: "merchant.username", width: 150},
            {label: "操作IP", property: "ip", width: 150},
            {label: "时间", property: "create_at", width: 160},
            {label: "内容", property: "content", position: "left"},
          ],
        },
      }
    },
    methods: {
      //获取表格数据
      async getTableList() {
        let nv = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize,
        };
        let res = await this.$Http.getSyslog(nv);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.tableData.tableList = this.getArray(res.data.list);
        }
      },
    },
    created() {
      this.getTableList();
    }
  }
</script>

<style scoped>

</style>
